import { render, staticRenderFns } from "./LabelModal7.vue?vue&type=template&id=276fc49d&scoped=true&"
import script from "./LabelModal7.vue?vue&type=script&lang=js&"
export * from "./LabelModal7.vue?vue&type=script&lang=js&"
import style0 from "./LabelModal7.vue?vue&type=style&index=0&id=276fc49d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276fc49d",
  null
  
)

export default component.exports